"use client";

import { Table } from "react-bootstrap";
import styles from "./info-tabs.module.scss";

const EcotopeTypesTab = () => {
  return (
    <div className={styles.tabContent} id="ecotope-types">
      <h2>Ecotope Types and Characteristics</h2>

      <p>
        The table below summarizes the biotic and abiotic characteristics of
        common ecotopes found in Irish peatlands. This classification helps
        ecologists and land managers assess the condition and restoration needs
        of different zones. This table was created by{" "}
        <a
          href="https://www.epa.ie/publications/research/biodiversity/Research_Report_342.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Regan et al. (2020)
        </a>
        , with definitions adapted from{" "}
        <a
          href="https://onlinelibrary.wiley.com/doi/abs/10.1111/j.1365-2486.2008.01724.x"
          target="_blank"
          rel="noopener noreferrer"
        >
          Schouten (2002)
        </a>
        .
      </p>
      <br />

      <Table striped bordered responsive className={styles.infoTable}>
        <thead style={{ fontWeight: "bold" }}>
          <tr>
            <th>Ecotope</th>
            <th>Abiotic Characteristics</th>
            <th>Biotic Characteristics</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Facebank</td>
            <td>
              No hummocks and hollows
              <br />
              Acrotelm usually absent
            </td>
            <td>
              Few or no peat-forming plant communities
              <br />
              Vegetation dominated by <em>Calluna vulgaris</em>
            </td>
          </tr>
          <tr>
            <td>Marginal</td>
            <td>
              No hummocks and hollows
              <br />
              Acrotelm usually absent or poorly developed (&lt;0.05 m)
            </td>
            <td>
              Few or no peat-forming plant communities
              <br />
              Vegetation dominated by <em>Calluna vulgaris</em> and{" "}
              <em>Trichophorum cespitosum</em>
            </td>
          </tr>
          <tr>
            <td>Sub-marginal</td>
            <td>
              Some differentiation between hummocks and hollows
              <br />
              Hollows inundated during small fraction of the year
              <br />
              Acrotelm absent or thin (&lt;0.05 m)
            </td>
            <td>
              Hollows dominated by <em>Narthecium ossifragum</em> and{" "}
              <em>Sphagnum tenellum</em>
            </td>
          </tr>
          <tr>
            <td>Sub-central</td>
            <td>
              A micro-topography of hummocks, hollows and lawns, but no pools
              <br />
              Lawns are dominant
              <br />
              Acrotelm depth variable from 0.10 m to 0.40 m
            </td>
            <td>
              Lawns dominated by <em>Sphagnum magellanicum</em>
            </td>
          </tr>
          <tr>
            <td>Central</td>
            <td>
              A micro-topography of hummocks, hollows and pools
              <br />
              Acrotelm moderately to well developed
              <br />
              Depth up to 0.5 m
            </td>
            <td>
              Pools and hollows dominated by <em>Sphagnum cuspidatum</em>
            </td>
          </tr>
          <tr>
            <td>Active flush/soak</td>
            <td>
              Wet to extremely wet conditions
              <br />
              Pools, hollows, lawns, and large flat hummocks
              <br />
              Acrotelm well developed (&gt;0.4 m)
            </td>
            <td>
              <em>Sphagnum cuspidatum</em> and <em>Sphagnum recurvum</em> lawns
              with <em>Carex rostrata</em>
              <br />
              <em>Myrica gale</em> and <em>Betula pubescens</em> scrub with{" "}
              <em>Sphagnum palustre</em>
              <br />
              <em>Molinia caerulea</em> tussocks in some areas
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default EcotopeTypesTab;
